var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowToPlayPrediction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3213_3324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0006 29.9992L30 -0.00140381L-0.000603696 29.9992L30 59.9998L60.0006 29.9992Z",
    fill: "url(#paint0_linear_3213_3324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55664 29.5176L28.2213 34.3836L15.4648 19.6057L5.55664 29.5176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4266 35.8153L5.82397 30.7502L19.9204 44.8467C19.9434 44.7702 19.9702 44.6936 20.0047 44.617L21.8423 40.5856C21.8423 40.5856 24.6678 37.787 29.4266 37.5688V35.8153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5767 35.7195V37.5687C35.3316 37.7831 38.1609 40.5855 38.1609 40.5855C38.1609 40.5855 39.3822 43.3152 39.9832 44.6169C40.0215 44.6973 40.0483 44.7777 40.0713 44.8581L54.1907 30.7386L30.5767 35.7195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4285 5.64691L16.2815 18.7901L29.4285 34.0198V5.64691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0029 49.2265C27.3957 49.2265 25.045 48.8054 23.2456 48.1699L30.0029 54.9271L36.7602 48.1699C34.9646 48.8054 32.6139 49.2303 30.0029 49.2303V49.2265Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5811 18.6522L31.2036 34.4141L54.4425 29.5136L43.5811 18.6522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5767 33.3537L42.7666 17.833L30.5767 5.64691V33.3537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1819 41.4545L40.6365 41.7273L40.091 44.7273L30.0001 55.0909L19.9092 44.7273L20.1819 41.4545Z",
    fill: "url(#paint1_linear_3213_3324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55664 29.5176L28.2213 34.3836L15.4648 19.6057L5.55664 29.5176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4266 35.8153L5.82397 30.7502L19.9204 44.8467C19.9434 44.7701 19.9702 44.6935 20.0047 44.617L21.8423 40.5856C21.8423 40.5856 24.6678 37.7869 29.4266 37.5687V35.8153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5767 35.7195V37.5687C35.3316 37.7831 38.1609 40.5855 38.1609 40.5855C38.1609 40.5855 39.3822 43.3152 39.9832 44.6169C40.0215 44.6973 40.0483 44.7777 40.0713 44.8581L54.1907 30.7386L30.5767 35.7195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4285 5.64691L16.2815 18.7901L29.4285 34.0198V5.64691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5811 18.6522L31.2036 34.4141L54.4425 29.5136L43.5811 18.6522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5767 33.3537L42.7666 17.833L30.5767 5.64691V33.3537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0014 44.3491C36.5286 44.3491 41.8199 39.0578 41.8199 32.5306C41.8199 26.0034 36.5286 20.712 30.0014 20.712C23.4742 20.712 18.1829 26.0034 18.1829 32.5306C18.1829 39.0578 23.4742 44.3491 30.0014 44.3491Z",
    fill: "white",
    stroke: "#000212",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1107 27.5809C29.9058 27.91 29.7831 28.2763 29.7426 28.65C29.3751 28.4665 28.9231 28.4067 28.483 28.5657C28.7509 27.9436 28.5668 27.2529 28.1621 26.8262L28.1268 26.7887L30.3637 24.6762L31.9804 26.3881C31.4545 26.4498 30.9427 26.6753 30.5262 27.0698L30.1107 27.4635V27.5809Z",
    fill: "white",
    stroke: "#0C0115",
    strokeWidth: 2.66169
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0767 32.1009L23.4393 30.8439L24.4702 31.9624C24.9001 32.4288 25.461 32.6968 26.0419 32.766C25.8499 33.1389 25.7937 33.5924 25.945 34.0264C25.3399 33.7582 24.646 33.9077 24.196 34.3296L24.1619 34.3611L22.0767 32.1009Z",
    fill: "white",
    stroke: "#0C0115",
    strokeWidth: 2.66169
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.873 37.7565C30.3202 37.3288 30.578 36.7774 30.6442 36.2069C31.0155 36.3949 31.4676 36.4503 31.901 36.2953C31.6308 36.917 31.813 37.6082 32.2164 38.0363L32.2499 38.0722L30.0025 40.1748L28.3908 38.4522C28.9178 38.3926 29.4304 38.169 29.8469 37.7814L29.8645 37.765L29.873 37.7565ZM30.3632 40.5603L30.3607 40.5577L30.3632 40.5603L30.3632 40.5603ZM26.5799 37.9636L26.5841 37.9668L26.5799 37.9636Z",
    fill: "white",
    stroke: "#0C0115",
    strokeWidth: 2.66169
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6899 31.779L34.4101 32.0588C34.2912 32.0284 34.1705 32.0067 34.0491 31.9938C34.234 31.6182 34.2819 31.1644 34.1238 30.7326C34.7465 31.0002 35.4379 30.8152 35.8642 30.4095L35.9035 30.3723L38.02 32.6031L36.3132 34.2225C36.2497 33.6965 36.0226 33.1857 35.6302 32.7715L34.6899 31.779ZM33.8732 30.4697L33.8725 30.4689L33.8732 30.4697ZM38.4036 32.2391L38.4003 32.2422L38.4036 32.2391L38.4036 32.2391ZM35.0255 35.4444C35.0259 35.444 35.0262 35.4436 35.0266 35.4432L35.0255 35.4444Z",
    fill: "white",
    stroke: "#0C0115",
    strokeWidth: 2.66169
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7683 34.8393L43.2629 36.3447L44.7683 37.8501L46.2738 36.3447L44.7683 34.8393Z",
    fill: "#0C0115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3636 26.4165L47.8582 27.9219L49.3636 29.4273L50.869 27.9219L49.3636 26.4165Z",
    fill: "#0C0115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.702 23.5062L41.7319 24.4763L42.702 25.4464L43.6722 24.4763L42.702 23.5062Z",
    fill: "#0C0115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2382 11.8683L25.2681 12.8384L26.2382 13.8085L27.2083 12.8384L26.2382 11.8683Z",
    fill: "#0C0115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8395 28.3568L13.8096 27.3867L12.8395 26.4165L11.8693 27.3867L12.8395 28.3568Z",
    fill: "#0C0115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7276 14.9311L35.2222 16.4365L36.7276 17.9419L38.233 16.4365L36.7276 14.9311Z",
    fill: "#0C0115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1807 17.9938L20.6753 19.4992L22.1807 21.0046L23.6861 19.4992L22.1807 17.9938Z",
    fill: "#0C0115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9069 37.4672L16.4124 35.9618L14.9069 34.4564L13.4015 35.9618L14.9069 37.4672Z",
    fill: "#0C0115"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3213_3324",
    x1: 26.5789,
    y1: 56.5787,
    x2: 2.06393,
    y2: 30.9158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFD7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF80F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3213_3324",
    x1: 30.2728,
    y1: 41.4545,
    x2: 30.2728,
    y2: 55.0909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84569D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3213_3324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToPlayPrediction);
export default __webpack_public_path__ + "static/media/how-to-play_prediction.8c6315a33a2cf14937ca3da479b07469.svg";
export { ForwardRef as ReactComponent };